export default {
    "results": {
        "viewTitle": "Anzeige: {text}",
        "unselectableViewDisplay": "<Andere>",
        "resultsListView": {
            "display": "Liste",
            "selectDocument": "Dokument auswählen",
            "unselectDocument": "Dokumentauswahl aufheben",
            "previewPopup": "[Dokument-Navigator]",
            "previewInCurrentPage": "[Dokument-Navigator (auf der aktuellen Seite)]",
            "previewInNewTab": "[Dokument-Navigator (in einem neuen Reiter)]",
            "showMetadata": "[Metadaten]",
            "showLabels": "[Etiketten]"
        },
        "resultsGridView": {
            "display": "Tabelle",
            "selectDocument": "Dokument auswählen",
            "unselectDocument": "Dokumentauswahl aufheben",
            "selectDocuments": "Dokumente auswählen",
            "unselectDocuments": "Dokumentauswahl aufheben"
        },
        "viewPageSize": "Anzahl der Ergebnisse pro Seite",
        "viewUpdateApply": "Anwenden",
        "warningNoViewForTab": "Der Reiter '{tab}' hat keine zugewiesenen Ergebnisansichten.",
        "warningCannotDisplayTabOnView": "Der Reiter '{tab}' kann nicht mit der Ansicht '{view}' angezeigt werden, da diese nicht in der Ansichtskonfiguration enthalten ist.",

        "resultsAllTab": "Alle",
        "resultsTextTab": "Text",
        "results_all_tab": "Alle",
        "results_text_tab": "Text",
    }
};
